import React, { useState } from "react";

import {
    ColorPickerDialog,
    ColorSwatch,
    LanguageSegmentedControl,
    RadioGroup,
    SectionCard,
    Stack,
    TextInput,
} from "shared/ui";

import { ITEM_PHOTOS_MODE_OPTIONS } from "features/MenuSettings/constants";
import { useMenuSettingsContext } from "features/MenuSettings/context";

import { MenuCoverCard } from "./components/MenuCoverCard";
import { Swatches } from "./styles";

type ColorField = "buttonsBackgroundColor" | "categoriesBackgroundColor";

const COLOR_FIELDS: { field: ColorField; label: string }[] = [
    { field: "buttonsBackgroundColor", label: "Цвет кнопок" },
    { field: "categoriesBackgroundColor", label: "Цвет категорий" },
];

export const AppearanceTab = () => {
    const { appearance, menuFlags, locale, isOldPriceLabelEnabled } =
        useMenuSettingsContext();

    const [editingColor, setEditingColor] = useState<ColorField | null>(null);
    const [activeLang, setActiveLang] = useState<string>(locale);

    return (
        <>
            <MenuCoverCard />

            <SectionCard title="Цвета">
                <Swatches>
                    {COLOR_FIELDS.map((item) => (
                        <ColorSwatch
                            key={item.field}
                            color={appearance.theme[item.field]}
                            label={item.label}
                            onClick={() => setEditingColor(item.field)}
                        />
                    ))}
                </Swatches>
            </SectionCard>

            <SectionCard title="Отображение позиций">
                <RadioGroup
                    value={appearance.theme.storefrontPhotosMode}
                    options={ITEM_PHOTOS_MODE_OPTIONS}
                    onChange={(value) =>
                        appearance.setThemeField("storefrontPhotosMode", value)
                    }
                />
            </SectionCard>

            {isOldPriceLabelEnabled && (
                <SectionCard
                    title="Подпись к зачёркнутой цене"
                    description="Гость увидит её над зачёркнутой ценой у позиций, где та задана. Если оставить пустой — будет показана только зачёркнутая цена."
                    headerRight={
                        <LanguageSegmentedControl
                            languages={menuFlags.enabledLocales}
                            activeLang={activeLang}
                            primaryLang={locale}
                            onChange={setActiveLang}
                            isMissing={(lang) =>
                                !(appearance.theme.oldPriceLabel || {})[lang]
                            }
                        />
                    }
                >
                    <Stack>
                        <TextInput
                            value={(appearance.theme.oldPriceLabel || {})[activeLang]}
                            onChange={(value) =>
                                appearance.setLocalizedOldPriceLabel(value, activeLang)
                            }
                            placeholder="Например, «Цена в других заведениях»"
                        />
                    </Stack>
                </SectionCard>
            )}

            <ColorPickerDialog
                open={!!editingColor}
                title={
                    editingColor === "categoriesBackgroundColor"
                        ? "Цвет категорий"
                        : "Цвет кнопок"
                }
                initialColor={editingColor ? appearance.theme[editingColor] : null}
                onClose={() => setEditingColor(null)}
                onApply={(color) => {
                    appearance.setThemeField(editingColor, color);
                    setEditingColor(null);
                }}
            />
        </>
    );
};
